import styled from 'styled-components';
import { Radio } from '@mui/material';

import colors from '../../../../styles/colors';

/*
 * An offering closing within days, or already closed, is shaded so it reads before the date does.
 */
const ACCEPT_UNTIL_SHADING = {
  CLOSING_SOON: { background: colors.shades.danger2, border: colors.shades.danger4 },
  CLOSED: { background: colors.shades.gamma5, border: colors.shades.gamma8 },
};

const PackageCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1.5px solid ${({ $selected, $acceptUntilState }) => {
    if ($selected) return colors.base.secondary;
    return ACCEPT_UNTIL_SHADING[$acceptUntilState]?.border || colors.shades.gamma1;
  }};
  background-color: ${({ $acceptUntilState }) => (
    ACCEPT_UNTIL_SHADING[$acceptUntilState]?.background || colors.base.alpha
  )};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  box-shadow: 0 1px 3px ${colors.addAlpha(colors.base.beta, 0.06)};
  transition: border-color 0.15s;
  opacity: ${({ $isOfferingDisabled }) => ($isOfferingDisabled ? 0.5 : 1)};

  &:hover {
    border-color: ${({ $disabled, $selected, $acceptUntilState }) => {
    if ($selected) return colors.base.secondary;
    if ($disabled) return ACCEPT_UNTIL_SHADING[$acceptUntilState]?.border || colors.shades.gamma1;
    return colors.shades.secondary2;
  }};
  }
`;

const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const PriceText = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${colors.base.beta};
`;

const StyledRadio = styled(Radio)`
  && {
    padding: 0;
    color: ${colors.shades.gamma3};

    &.Mui-checked {
      color: ${colors.base.secondary};
    }
  }
`;

const PackageName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.base.beta};
  margin-bottom: 1px;
`;

const PriceTermText = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: ${colors.shades.gamma10};
  margin-right: auto;
`;

const FeatureDivider = styled.div`
  border-top: 1px solid ${colors.shades.gamma1};
  margin-bottom: 4px;
`;

const DisabledText = styled.span`
  margin-right: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.shades.gamma10};
`;

const AcceptUntilRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 8px;
`;

const AcceptUntilLabel = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${colors.shades.gamma10};
`;

const AcceptUntilDate = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${colors.base.warning};
`;

const ChallengeStartDate = styled(AcceptUntilDate)`
  color: ${colors.shades.gamma10};
`;

export {
  AcceptUntilDate,
  AcceptUntilLabel,
  AcceptUntilRow,
  CardHeaderRow,
  ChallengeStartDate,
  DisabledText,
  FeatureDivider,
  PriceTermText,
  PackageCard,
  PackageName,
  PriceRow,
  PriceText,
  StyledRadio,
};
